/**
 * 모델의 자리 표시 — 자리 번호(1부터)를 사람에게 보이는 글(«Model N»). 정본 하나(D-116).
 * 이름이 없거나 이름을 쓸 수 없는 자리(커플링 검증·결선 문구, 커플링 화면, 새 프로젝트 마법사, 퀵 실행 카드의 자리 칩·자리 표시 이름)가
 * 이것을 쓴다 — 자리 표시를 고치면 모든 문구와 칩이 함께 바뀐다. 전에는 자리마다 `Model ${…}` 를 따로 적었다.
 */
export const modelSlotLabel = (slot: number): string => `Model ${slot}`;
